import * as React from "react";
// import { pure } from 'recompose';
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import Stream from "@tunnel-components/@sharded/widgets/stream/component";
import Patterns from "@tunnel-components/@sharded/widgets/patterns-incident/component";
import * as Lodash from "lodash";
import * as Enums from "@tunnel-enums/index";
import SeaPatterns from "@tunnel-components/@sharded/widgets/sae/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    authorization,
    itemslabelIncident,
    onClosePattern,
    rediRectToo,
    onSubmitSeaPatterns,
    onCloseSeaPatterns,
    actionSeaPatterns,
    actionFalseAlarmPatterns,
    onSearchValue,
    onSubmitPatterns,
    onChangePatterns,
    patternfalseAlarm,
    selectedValue,
    actionFalseAlarmPatternsError,
    /*actionSeaPatterns,*/ item,
    deleteFakeFunction,
    actionLoader,
    isQualifyFunction,
    isQualifyFunctionFalse,
    identifiantActifSea,
  } = props;
  /**
   * @description : retourne un objet
   * @const
   * @name User
   * @type { any  }
   */

  const User: any = Utils.createdUserRoles();
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  const SYSTEMVIEWTUBES: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  return (
    <li className="vcartIncidents heightIncidents">
      <div className="cart-incident">
        <div className="cartIncidentHeader mixCartIncidentHeader">
          <div className="incidentHeaderTextleft">
            {!!item && item.label && (
              <span className="incidentLabel">
                {!!item && i18next.t(`${item.label}`)} #{!!item && item.id}
              </span>
            )}
            -
            <span
              className="incidentLabel"
              style={{
                fontWeight: 500,
                color: "black",
                padding: "0 3px",
                borderRadius: "5px",
                marginLeft: "5px",
              }}
            >
              {!!item &&
                !Lodash.isUndefined(item.camera) &&
                !!item.camera &&
                item.camera.code}
            </span>
            <span style={{ height: "22px", float: "right" }}>
              {false && (
                <svg
                  width="26"
                  height="20"
                  viewBox="0 0 26 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M5.33333 6.19305V13.6422C5.33333 13.8924 5.53618 14.0952 5.78635 14.0952H9.85325V15.0821H9.12465C8.87448 15.0821 8.67164 15.2849 8.67164 15.5351C8.67164 15.7853 8.87448 15.9881 9.12465 15.9881H13.9487C14.1988 15.9881 14.4017 15.7853 14.4017 15.5351C14.4017 15.2849 14.1988 15.0821 13.9487 15.0821H13.2201V14.0952H17.287C17.5372 14.0952 17.74 13.8924 17.74 13.6422V6.19305C17.74 5.94284 17.5372 5.74004 17.287 5.74004H5.78635C5.53614 5.74004 5.33333 5.94284 5.33333 6.19305ZM12.3141 15.0375H10.7593V14.0953H12.3141V15.0375ZM6.23937 6.64607H16.834V13.1892H12.7671H10.3063H6.23937V6.64607Z"
                      fill="#028DFF"
                    />
                    <path
                      d="M21.3333 10.5807V3.13153C21.3333 2.88132 21.1305 2.67851 20.8803 2.67851H9.37962C9.12944 2.67851 8.9266 2.88132 8.9266 3.13153V4.88007C8.9266 5.13024 9.12944 5.33309 9.37962 5.33309C9.62979 5.33309 9.83263 5.13024 9.83263 4.88007V3.58455H20.4273V10.1277H19.0628C18.8127 10.1277 18.6098 10.3306 18.6098 10.5807C18.6098 10.8309 18.8127 11.0337 19.0628 11.0337H20.8803C21.1306 11.0337 21.3333 10.8309 21.3333 10.5807Z"
                      fill="#028DFF"
                    />
                  </g>
                  <path
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H22.3333C23.714 0.5 24.8333 1.61929 24.8333 3V17C24.8333 18.3807 23.714 19.5 22.3333 19.5H3C1.61929 19.5 0.5 18.3807 0.5 17V3Z"
                    stroke="#028DFF"
                  />
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(5.33333 1.33333)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </span>
          </div>
        </div>
        {
          /*!actionSeaPatterns[index]*/ !!item &&
            !Lodash.isEqual(identifiantActifSea, item.id) &&
            actionFalseAlarmPatterns && (
              <div className="cartIncidentContentInsider">
                <Patterns
                  style={{ height: "70px" }}
                  actionFalseAlarmPatternsError={actionFalseAlarmPatternsError}
                  onSubmit={onSubmitPatterns}
                  onChangePatterns={onChangePatterns}
                  patternfalseAlarm={patternfalseAlarm}
                  selectedValue={selectedValue}
                  onSearchValue={onSearchValue}
                  items={itemslabelIncident}
                  onClosePattern={onClosePattern}
                />
              </div>
            )
        }
        {
          /*actionSeaPatterns[index]*/ !!item && actionSeaPatterns && (
            <div className="cartIncidentContentInsider">
              <SeaPatterns
                onSubmitSeaPatterns={onSubmitSeaPatterns}
                onCloseSeaPatterns={onCloseSeaPatterns}
              />
            </div>
          )
        }

        {!!item &&
          !Lodash.isEqual(identifiantActifSea, item.id) &&
          !actionFalseAlarmPatterns && (
            <div className="cartIncidentContentInsider">
              <div className="cartIncidentContentIN">
                {!!actionLoader && (
                  <div className="actionLoader">
                    <div className="lds-spinner">
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                )}
                {!!item &&
                  !item.fake &&
                  Utils.simpleAuthorizationIsAllowed(User, [
                    Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTSDETAILS,
                  ]) && (
                    <Link
                      to={`${Paths.PathsNamesEnums.TUNNELWATCHINCIDENTFILE}${item.id}`}
                    >
                      {!!item && !item.snapshotMim && (
                        <div className="impossible  animated fadeIn" />
                      )}
                      {!!item && item.snapshotMim && (
                        <div className="image-live  animated fadeIn">
                          <Stream
                            localUrl={!!item && item.snapshotMim}
                            name={!!item && item.camera && item.camera.code}
                            classnames=" animated fadeIn"
                          />
                        </div>
                      )}
                    </Link>
                  )}
                {!!item &&
                  !item.fake &&
                  Utils.simpleAuthorizationIsAllowed(User, [
                    Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTSDETAILS,
                  ]) &&
                  !item.terminated &&
                  false && (
                    <a
                      onClick={rediRectToo}
                      style={{ cursor: "pointer" }}
                      className="incident-encours"
                    >
                      {!!item && !item.snapshotMim && (
                        <div className="impossible  animated fadeIn" />
                      )}
                      {!!item && item.snapshotMim && (
                        <div className="image-live  animated fadeIn">
                          <Stream
                            localUrl={!!item && item.snapshotMim}
                            name={!!item && item.camera && item.camera.code}
                            classnames=" animated fadeIn"
                          />
                        </div>
                      )}
                    </a>
                  )}
                {!!item && item.fake && (
                  <div className="image-live image-snapshot  animated fadeIn flash">
                    <div className="came-lg">
                      <div className="simulationIncident" />
                      <p
                        style={{
                          fontWeight: 600,
                          color: "white",
                          position: "absolute",
                          top: "80%",
                          width: "100%",
                          zIndex: 9999,
                        }}
                      >
                        {i18next.t("simulation")}
                      </p>
                    </div>
                  </div>
                )}

                <div className="incidentDateInfos">
                  {!!item && item.startTime && (
                    <div
                      className="left part-left"
                      style={{ lineHeight: "30px" }}
                    >
                      <span>{Utils.localDateFrFormat(item.startTime)}</span>
                    </div>
                  )}
                  {SYSTEMVIEWTUBES && !!item && item && item.camera && (
                    <div className="left part-right">
                      {!!item &&
                        !Lodash.isUndefined(item.camera) &&
                        !Lodash.isUndefined(item.camera.section) &&
                        !!item.camera && (
                          <span
                            style={{
                              backgroundColor:
                                item.camera.section.colorRgbString,
                              position: "absolute",
                              color: "white",
                              right: "2px",
                              top: "50%",
                              height: "25px",
                              lineHeight: "25px",
                              padding: "0 5px",
                              transform: "translateY(-50%)",
                              borderRadius: "3px",
                            }}
                            className="smallTubeColor"
                          >
                            {item.camera.section.name}
                          </span>
                        )}
                    </div>
                  )}
                </div>
              </div>
              {!!item && !item.qualified && authorization && (
                <div className="cart-incident-footer animated fadeInUp">
                  <div className="footer-actions">
                    <div className="left part-left">
                      {!!item && !item.fake && (
                        <span>{i18next.t("a qualifier")}</span>
                      )}
                      {!!item &&
                        item.fake &&
                        Utils.simpleAuthorizationIsAllowed(User, [
                          Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
                        ]) && <span> {i18next.t("supprimer")}</span>}
                    </div>
                    <div className="left part-right">
                      <span>
                        {!!item &&
                          item.fake &&
                          Utils.simpleAuthorizationIsAllowed(User, [
                            Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
                          ]) && (
                            <div
                              onClick={deleteFakeFunction}
                              title={i18next.t("supprimer")}
                              className="icon-trash left"
                            />
                          )}
                        {!!item && !item.fake && (
                          <div
                            onClick={isQualifyFunction}
                            title={i18next.t("avere")}
                            className="icon-check left"
                          />
                        )}
                        {!!item && !item.fake && (
                          <div
                            onClick={isQualifyFunctionFalse}
                            title={i18next.t("fausse alarmes")}
                            className="left icon-fauses-alert"
                          />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {!!item && item.qualified && item.truePositive && (
                <div className="cart-incident-footer out-of-qualified animated fadeInUp">
                  <div className="footer-actions ">
                    <div className="left part-left">
                      <span>{i18next.t("avere")}</span>
                    </div>
                    <div className="left part-right">
                      <span>
                        {!!item &&
                          item.fake &&
                          Utils.simpleAuthorizationIsAllowed(User, [
                            Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
                          ]) && <div className="icon-trash-gray left" />}
                        {!!item && !item.fake && (
                          <div className="icon-check-green left" />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {!!item && item.qualified && item.falsePositive && (
                <div className="cart-incident-footer out-of-qualified animated fadeInUp">
                  <div className="footer-actions ">
                    <div className="left part-left" style={{ width: "80%" }}>
                      <span>
                        {" "}
                        {i18next.t("fausse alerte")} :{" "}
                        {i18next.t(`${item.qualificationMotifAs}`)}
                      </span>
                    </div>
                    <div className="left part-right" style={{ width: "20%" }}>
                      <span>
                        {item.fake &&
                          Utils.simpleAuthorizationIsAllowed(User, [
                            Enums.AuthorizationRightsEnums.SIMULATORDELECTED,
                          ]) && <div className="icon-trash-gray left" />}
                        {!!item && !item.fake && (
                          <div className="left icon-fauses-alert-gray" />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {!!item && !item.qualified && !authorization && (
                <div className="cart-incident-footer  animated fadeInUp " />
              )}
            </div>
          )}
      </div>
    </li>
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  authorization: boolean;
  item: any;
  isQualifyFunction: any; // ok
  deleteFakeFunction: any; // ok
  impacts: boolean;
  actionLoader?: any[]; // ok
  actionFalseAlarmPatterns?: any;
  actionSeaPatterns?: any;
  index?: number; // ok
  onSubmitPatterns?: any;
  onSubmitSeaPatterns?: any;
  onCloseSeaPatterns?: any;
  onChangePatterns?: any;
  patternfalseAlarm?: any;
  itemslabelIncident?: any;
  actionFalseAlarmPatternsError?: any;
  identifiantActifSea?: any;
  onSearchValue?: any;
  selectedValue?: any;
  isQualifyFunctionFalse?: any; // ok
  onClosePattern?: any;
  rediRectToo?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/incidents/component.tsx